export const TARGET_LEAGUES = [
    { code: 'EPL', name: '英超', aliases: ['英超', '英格兰超级联赛'], country: '英格兰', priority: 1, sclassId: 36 },
    { code: 'LIGUE1', name: '法甲', aliases: ['法甲', '法国甲级联赛'], country: '法国', priority: 2, sclassId: 11 },
    { code: 'BUNDESLIGA', name: '德甲', aliases: ['德甲', '德国甲级联赛'], country: '德国', priority: 3, sclassId: 8 },
    { code: 'EREDIVISIE', name: '荷甲', aliases: ['荷甲', '荷兰甲级联赛'], country: '荷兰', priority: 4, sclassId: 16 },
    { code: 'LALIGA', name: '西甲', aliases: ['西甲', '西班牙甲级联赛'], country: '西班牙', priority: 5, sclassId: 31 },
    { code: 'ELITESERIEN', name: '挪超', aliases: ['挪超', '挪威超级联赛'], country: '挪威', priority: 6, sclassId: 22 },
    { code: 'CHAMPIONSHIP', name: '英冠', aliases: ['英冠', '英格兰冠军联赛'], country: '英格兰', priority: 7, sclassId: 37 },
    { code: 'J1', name: '日职', aliases: ['日职', '日职联', '日本职业联赛'], country: '日本', priority: 8, sclassId: 25 },
    { code: 'ALLSVENSKAN', name: '瑞超', aliases: ['瑞超', '瑞典超', '瑞典超级联赛'], country: '瑞典', priority: 9, sclassId: 26 },
    { code: 'SERIE_A', name: '意甲', aliases: ['意甲', '意大利甲级联赛'], country: '意大利', priority: 10, sclassId: 34 },
    { code: 'PRIMEIRA', name: '葡超', aliases: ['葡超', '葡萄牙超级联赛'], country: '葡萄牙', priority: 11, sclassId: 23 },
    { code: 'K_LEAGUE_1', name: '韩职', aliases: ['韩职', '韩K联', '韩国职业联赛'], country: '韩国', priority: 12, sclassId: 15 },
    { code: 'A_LEAGUE', name: '澳超', aliases: ['澳超', '澳大利亚超级联赛'], country: '澳大利亚', priority: 13, sclassId: 273 },
    { code: 'J2', name: '日乙', aliases: ['日乙', '日本乙级联赛'], country: '日本', priority: 14, sclassId: 0 },
    { code: 'MLS', name: '美职', aliases: ['美职', '美职业', '美国职业大联盟'], country: '美国', priority: 15, sclassId: 21 },
    { code: 'BRASILEIRAO', name: '巴甲', aliases: ['巴甲', '巴西甲级联赛'], country: '巴西', priority: 16, sclassId: 0 },
    { code: 'ARGENTINA', name: '阿甲', aliases: ['阿甲', '阿根廷甲级联赛'], country: '阿根廷', priority: 17, sclassId: 2 },
    { code: 'SAUDI', name: '沙特联', aliases: ['沙特联', '沙特阿拉伯职业联赛'], country: '沙特', priority: 18, sclassId: 292 },
    { code: 'ACL', name: '亚冠', aliases: ['亚冠', '亚洲冠军联赛'], country: '亚洲', priority: 19, sclassId: 0, cup: true },
    { code: 'UECL', name: '欧协', aliases: ['欧协', '欧会杯', '欧洲协会联赛'], country: '欧洲', priority: 20, sclassId: 0, cup: true },
];
function normalize(value) {
    return value
        .replace(/\s+/g, '')
        .replace(/[·•\-_/]/g, '')
        .replace(/（[^）]*）/g, '')
        .replace(/\([^)]*\)/g, '')
        .toLowerCase();
}
function aliasMatches(normalized, alias) {
    const target = normalize(alias);
    if (!target)
        return false;
    if (normalized === target)
        return true;
    let index = normalized.indexOf(target);
    while (index >= 0) {
        const before = index > 0 ? normalized[index - 1] ?? '' : '';
        const after = index + target.length < normalized.length ? normalized[index + target.length] ?? '' : '';
        const beforeChinese = before === '' || /[\u4e00-\u9fff]/.test(before);
        const afterChinese = after === '' || /[\u4e00-\u9fff]/.test(after);
        if (!(beforeChinese && afterChinese))
            return true;
        index = normalized.indexOf(target, index + 1);
    }
    return false;
}
export function findTargetLeague(value) {
    const normalized = normalize(value);
    return TARGET_LEAGUES.find((league) => league.aliases.some((alias) => aliasMatches(normalized, alias))) ?? null;
}
export function getTargetLeague(code) {
    return TARGET_LEAGUES.find((league) => league.code === code) ?? null;
}
//# sourceMappingURL=leagues.js.map